<div style="display: flex">
  <div style="display: flex; flex-direction: column; flex: 1vh">
    <div style="display: flex; flex-direction: row; flex: 100vh">
      <div style="display: flex; flex-direction:column; flex: 0 50vw; align-items: center;">
        <div style="width: 400px; margin: auto; padding: 20px;">
          <h2 style="text-align: center; margin-bottom: 20px;">Reset Password</h2>
          
          <form *ngIf="reactiveForm" [formGroup]="reactiveForm" (ngSubmit)="resetPassword(null)" autocomplete="off">
            <div style="margin-bottom: 20px;">
              <label for="newPassword" style="display: block; margin-bottom: 5px; font-weight: 600;">New Password</label>
              <input 
                id="newPassword" 
                type="password" 
                formControlName="newPassword" 
                pInputText
                style="width: 100%;"
                class="simple-control"
                autocomplete="new-password" />
              <dynamic-control-error 
                [formControl]="reactiveForm.get('newPassword')" 
                [controlName]="'New Password'">
              </dynamic-control-error>
              <password-strength-indicator 
                [control]="reactiveForm.get('newPassword')" 
                [minLength]="8" 
                [showTips]="true">
              </password-strength-indicator>
            </div>

            <div style="margin-bottom: 20px;">
              <label for="confirmNewPassword" style="display: block; margin-bottom: 5px; font-weight: 600;">Confirm New Password</label>
              <input 
                id="confirmNewPassword" 
                type="password" 
                formControlName="confirmNewPassword" 
                pInputText
                style="width: 100%;"
                class="simple-control"
                autocomplete="new-password" />
              <dynamic-control-error 
                [formControl]="reactiveForm.get('confirmNewPassword')" 
                [controlName]="'Confirm New Password'">
              </dynamic-control-error>
            </div>

            <div style="display: flex; justify-content: space-between; margin-top: 30px;">
              <button 
                type="button" 
                (click)="clickButton('cancel')" 
                class="p-button p-button-secondary"
                style="margin-right: 10px;">
                Cancel
              </button>
              <button 
                type="submit" 
                [disabled]="!reactiveForm.valid"
                class="p-button p-button-primary">
                Reset Password
              </button>
            </div>
          </form>
          
          <!-- Fallback to dynamic form -->
          <dynamic-form 
            *ngIf="!reactiveForm" 
            [model]="form" 
            (clickSubmit)="resetPassword($event)" 
            (clickButton)="clickButton($event)">
          </dynamic-form>
        </div>
      </div>
      <div class="login-hero">
        <div class="login-hero-text">
          Join the most satisfied auto transport customers in the country.
        </div>
      </div>
    </div>
  </div>
</div>





